<template>
  <section v-if="company" class="company_container">
    <div class="company__wrapper">
      <div :id="`${company.id}`" class="company">
        <div class="company__details">
          <i class="company-icon icon-home-circled"></i>

          <div class="company-name">
            <h3>{{ company.name }}</h3>
            <template v-if="company.contact">
              <div class="company-address">
                <span class="street">{{ company.contact.streetAddress }}</span>
                <span class="post">{{ company.contact.postalCode }} {{ company.contact.postOffice }}</span>
              </div>
            </template>
          </div>

          <div class="company-contact">
            <div class="company-contacts-wrapper">
              <div>
                <a
                  v-if="company.contact && company.contact.phone"
                  :href="`tel:${company.contact.phone}`"
                  class="contact telephone"
                >
                  <i class="icon-phone-circled"></i>
                  <span>{{ company.contact.phone }}</span>
                </a>
                <RouterLink
                  class="call-pricing-link basic-link"
                  :to="`${staticPage.paths.pricing}#puheluhinnat`"
                  tabindex="0"
                >
                  Katso puheluhinnat
                </RouterLink>
              </div>
              <div>
                <span v-if="company.contact && company.contact.email" class="contact email">
                  <i class="icon-mail-circled"></i>
                  <span>{{ company.contact.email }}</span>
                </span>
              </div>
            </div>
          </div>

          <div class="company-code-details">
            <div class="company-code">
              <span class="vat-code">Y-Tunnus: {{ company.vatCode }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { staticPage } from '@/app/routes';
import type { CompanyDetailType } from '@/schemas/companySchema';

defineProps<{
  company?: CompanyDetailType | null; //used to be default: null, should it stay so?
}>();
</script>
